import { useCartState } from "@made-people/grease-cart";
import { useCountryContent } from "./use-country-content";
import { formatLikePrice } from "../utils/format-like-price";
import { useMmFreeShippingThreshold } from "../experiments/free-shipping-threshold/use-mm-free-shipping-threshold";

export const useShippingThreshold = () => {
  const { cart } = useCartState();
  const countryContent = useCountryContent();
  const { shouldUseGrowthbookThreshold, growthbookCurrencyConfig } =
    useMmFreeShippingThreshold();
  const { shippingThresholdValue = "0", shippingThresholdIsEnabled = false } =
    countryContent ?? {};

  let threshold: number;
  let thresholdEnabled: boolean;
  if (shouldUseGrowthbookThreshold()) {
    thresholdEnabled = Boolean(growthbookCurrencyConfig?.threshold ?? false);
    threshold = parseFloat(growthbookCurrencyConfig?.threshold ?? "0");
  } else {
    threshold = parseFloat(shippingThresholdValue);
    thresholdEnabled = Boolean(shippingThresholdIsEnabled);
  }

  const shipping = cart?.totals?.shipping;
  const grandTotal = cart?.totals?.grandTotal;

  const cartSubtotal =
    grandTotal && shipping ? grandTotal.number - shipping.number : 0;

  const isFreeShippingByThreshold =
    thresholdEnabled && !isNaN(threshold) && cartSubtotal >= threshold;

  const isFreeShippingByZeroShipping = shipping?.number === 0;
  const isFreeShipping =
    isFreeShippingByThreshold || isFreeShippingByZeroShipping;

  const hasFreeShippingGiftcard = cart?.vouchers?.some(
    (v) => v.type === "auto" && v.name === "Free shipping giftcard",
  );

  const remaining =
    grandTotal && !isNaN(threshold)
      ? formatLikePrice(threshold - cartSubtotal, grandTotal.formatted)
      : "";

  const thresholdFormatted =
    grandTotal && !isNaN(threshold)
      ? formatLikePrice(threshold, grandTotal.formatted)
      : "";

  return {
    thresholdEnabled,
    isFreeShipping,
    hasFreeShippingGiftcard: !!hasFreeShippingGiftcard,
    remaining,
    thresholdFormatted,
    hasCart: !!cart?.totals,
    threshold,
    isFreeShippingByZeroShipping,
  };
};
